/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2UserSingle/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2UserSingle({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2UserSingle",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2UserSingle.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-ZnAXHu': alignSelf,'--mt-2-ZnAXHu': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZnAXHu': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZnAXHu': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZnAXHu': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZnAXHu': opacity,'--w-10-ZnAXHu': typeof width === 'number' ? `${width}px` : width,'--h-11-ZnAXHu': typeof height === 'number' ? `${height}px` : height,'--f-12-ZnAXHu': fill,'--a-7-ZnAXHu': isAnimated ? animation : "none",'--sd-8-ZnAXHu': isAnimated ? strokeDashoffset : 0,'--sd-9-ZnAXHu': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2UserSingle.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M8.744 3a3 3 0 11-6 0 3 3 0 016 0zM.018 11.486a6.003 6.003 0 0111.45 0c.083.26-.121.514-.395.514H.413c-.273 0-.477-.253-.395-.514z"
 style={{'--f-12-ZnAXHu': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}